import { Section } from "./section";
import { SystemField } from "./system-field";

export class SitePage  extends SystemField{
     
	name?:string;
	image?:string;

	// Callback class
	sections?: Section [];
	all_sections?: Section [];

	// Import class translate
	langs?: any;
}

export class SitePagesTranslate  extends SystemField{
     
	lang_code?:string;
	title?:string;
	short_desc?:string;
	site_pages_id?:string;
}

export class ThemePage extends SitePage{}